import { logout } from '@/store/auth/authSlice';
import { AppDispatch } from '@/store/store';

export const authLogout = () => async (dispatch: AppDispatch) => {
  dispatch(logout());
  import('@/store/emptyApi').then(console.log);
  await import('@/store/emptyApi').then(({ emptyApi }) => emptyApi.util.resetApiState()).then(dispatch);
};
